module.exports = __webpack_public_path__ + "b069582690a359c6d38c3f476a4fb051.png";